import React from 'react';
import Helmet from 'react-helmet';
import { injectIntl, IntlShape } from 'react-intl';

import DiLayout from './DiLayout';
import LmHeader from './LmHeader';
import DiGenericLoading from './DiGenericLoading';

interface Props {
  intl: IntlShape;
  footerText?: string;
}

const DiGenericLoadingPage = ({ intl, footerText = 'Powered by Localmed' }: Props) => {
  const title = intl.formatMessage({
    id: 'DiLayout.DiGenericLoadingPage.title',
    defaultMessage: 'Loading…',
  });
  return (
    <DiLayout header={<LmHeader />} fullWidth footerText={footerText}>
      <Helmet>
        <title>{title}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <DiGenericLoading />
    </DiLayout>
  );
};

export default injectIntl(DiGenericLoadingPage);
